function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M13 1.75c6.213 0 11.25 5.037 11.25 11.25S19.213 24.25 13 24.25 1.75 19.213 1.75 13 6.787 1.75 13 1.75z",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.508 12.43l-.828-.56a.921.921 0 00-.034.054l.862.507zm-6.798.332l.803-.596a.94.94 0 00-.043-.054l-.76.65zm.787.77l-.618.786.618-.786zM11 14h1a1 1 0 00-.207-.609L11 14zm0 3h-1a1 1 0 001 1v-1zm4 0v1a1 1 0 001-1h-1zm0-3l-.793-.609A1 1 0 0014 14h1zm.503-.468l.618.786-.618-.786zM16 10.125c0 1.105-.17 1.524-.32 1.745l1.656 1.122c.477-.704.664-1.598.664-2.867h-2zM13 7c1.628 0 3 1.37 3 3.125h2C18 7.324 15.79 5 13 5v2zm-3 3.125C10 8.37 11.372 7 13 7V5c-2.79 0-5 2.324-5 5.125h2zm.47 1.987c-.229-.268-.47-.712-.47-1.987H8c0 1.535.295 2.52.95 3.287l1.52-1.3zm.644.633c-.236-.185-.416-.33-.6-.579l-1.607 1.191c.357.481.722.765.972.961l1.235-1.573zm.68.646c-.23-.3-.505-.509-.68-.646L9.88 14.318c.206.162.276.224.328.29l1.586-1.217zM12 17v-3h-2v3h2zm3-1h-4v2h4v-2zm-1-2v3h2v-3h-2zm.886-1.255c-.175.137-.45.347-.68.646l1.587 1.218c.052-.067.122-.129.328-.29l-1.235-1.574zm.76-.82c-.243.412-.476.597-.76.82l1.235 1.573c.333-.261.811-.635 1.25-1.38l-1.725-1.014z",
  fill: "#fff"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 20h4",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}
export default SvgBulb;